// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AiSandboxRouteImport } from './routes/ai-sandbox'
import { Route as ApiRouteImport } from './routes/api'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingV1PreviewRouteImport } from './routes/onboarding-v1-preview'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as PolicyRouteImport } from './routes/policy'
import { Route as StartRouteImport } from './routes/start'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppAgentsRouteImport } from './routes/_app/agents'
import { Route as AppBondsRouteImport } from './routes/_app/bonds'
import { Route as AppBoostedLimitOrdersRouteImport } from './routes/_app/boosted-limit-orders'
import { Route as AppBuildRouteImport } from './routes/_app/build'
import { Route as AppCommoditiesRouteImport } from './routes/_app/commodities'
import { Route as AppCreatePortfolioRouteImport } from './routes/_app/create-portfolio'
import { Route as AppCryptoRouteImport } from './routes/_app/crypto'
import { Route as AppCurrenciesRouteImport } from './routes/_app/currencies'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppDebugRouteImport } from './routes/_app/debug'
import { Route as AppExploreRouteImport } from './routes/_app/explore'
import { Route as AppExploreAllRouteImport } from './routes/_app/explore-all'
import { Route as AppInvestingAccountRouteImport } from './routes/_app/investing-account'
import { Route as AppOnboardingRouteImport } from './routes/_app/onboarding'
import { Route as AppOnboardingV2RouteImport } from './routes/_app/onboarding-v2'
import { Route as AppPreIpoRouteImport } from './routes/_app/pre-ipo'
import { Route as AppPrivateCreditRouteImport } from './routes/_app/private-credit'
import { Route as AppReferralsRouteImport } from './routes/_app/referrals'
import { Route as AppRewardsRouteImport } from './routes/_app/rewards'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppStocksRouteImport } from './routes/_app/stocks'
import { Route as DesignSystemIndexRouteImport } from './routes/design-system.index'
import { Route as DesignSystemSlugRouteImport } from './routes/design-system.$slug'
import { Route as RSlugRouteImport } from './routes/r.$slug'
import { Route as StartStepIdRouteImport } from './routes/start.$stepId'
import { Route as WelcomeStepIdRouteImport } from './routes/welcome.$stepId'
import { Route as AppAgentsWorkflowIdRouteImport } from './routes/_app/agents.$workflowId'
import { Route as AppAgentsTasksRouteImport } from './routes/_app/agents.tasks'
import { Route as AppBuildBlueprintIdRouteImport } from './routes/_app/build_.$blueprintId'
import { Route as AppCryptoSymbolRouteImport } from './routes/_app/crypto_.$symbol'
import { Route as AppOnboardingOnboardingIdRouteImport } from './routes/_app/onboarding.$onboardingId'
import { Route as AppPortfolioPortfolioInstanceIdRouteImport } from './routes/_app/portfolio.$portfolioInstanceId'
import { Route as AppReceiptReceiptIdRouteImport } from './routes/_app/receipt.$receiptId'
import { Route as AppSpPartnerRouteImport } from './routes/_app/sp.$partner'
import { Route as AppStocksSymbolRouteImport } from './routes/_app/stocks_.$symbol'
import { Route as AppStrategyBlueprintIdRouteImport } from './routes/_app/strategy.$blueprintId'
import { Route as AppSymbolSymbolRouteImport } from './routes/_app/symbol.$symbol'
import { Route as AppTemplateBlueprintIdRouteImport } from './routes/_app/template.$blueprintId'
import { Route as AppUserUserIdRouteImport } from './routes/_app/user.$userId'
import { Route as OnrampRobinhoodCallbackRouteImport } from './routes/onramp.robinhood.callback'
import { Route as AppAgentsTasksTaskIdRouteImport } from './routes/_app/agents.tasks.$taskId'
import { Route as AppAssetChainIdTokenAddressRouteImport } from './routes/_app/asset.$chainId.$tokenAddress'
import { Route as AppCryptoChainTokenAddressRouteImport } from './routes/_app/crypto_.$chain.$tokenAddress'
import { Route as AppSymbolChainIdSymbolRouteImport } from './routes/_app/symbol.$chainId.$symbol'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_app.lazy').then((d) => d.Route))
const AiSandboxRoute = AiSandboxRouteImport.update({
            id: '/ai-sandbox',path: '/ai-sandbox',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ai-sandbox.lazy').then((d) => d.Route))
const ApiRoute = ApiRouteImport.update({
            id: '/api',path: '/api',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/api.lazy').then((d) => d.Route))
const DesignSystemRoute = DesignSystemRouteImport.update({
            id: '/design-system',path: '/design-system',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/design-system.lazy').then((d) => d.Route))
const DevelopersRoute = DevelopersRouteImport.update({
            id: '/developers',path: '/developers',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const OnboardingV1PreviewRoute = OnboardingV1PreviewRouteImport.update({
            id: '/onboarding-v1-preview',path: '/onboarding-v1-preview',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/onboarding-v1-preview.lazy').then((d) => d.Route))
const PlatformRoute = PlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => rootRouteImport
          })
const PolicyRoute = PolicyRouteImport.update({
            id: '/policy',path: '/policy',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/policy.lazy').then((d) => d.Route))
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/start.lazy').then((d) => d.Route))
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/terms.lazy').then((d) => d.Route))
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const AppActivityRoute = AppActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/activity.lazy').then((d) => d.Route))
const AppAgentsRoute = AppAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/agents.lazy').then((d) => d.Route))
const AppBondsRoute = AppBondsRouteImport.update({
            id: '/bonds',path: '/bonds',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/bonds.lazy').then((d) => d.Route))
const AppBoostedLimitOrdersRoute = AppBoostedLimitOrdersRouteImport.update({
            id: '/boosted-limit-orders',path: '/boosted-limit-orders',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/boosted-limit-orders.lazy').then((d) => d.Route))
const AppBuildRoute = AppBuildRouteImport.update({
            id: '/build',path: '/build',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/build.lazy').then((d) => d.Route))
const AppCommoditiesRoute = AppCommoditiesRouteImport.update({
            id: '/commodities',path: '/commodities',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/commodities.lazy').then((d) => d.Route))
const AppCreatePortfolioRoute = AppCreatePortfolioRouteImport.update({
            id: '/create-portfolio',path: '/create-portfolio',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/create-portfolio.lazy').then((d) => d.Route))
const AppCryptoRoute = AppCryptoRouteImport.update({
            id: '/crypto',path: '/crypto',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/crypto.lazy').then((d) => d.Route))
const AppCurrenciesRoute = AppCurrenciesRouteImport.update({
            id: '/currencies',path: '/currencies',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/currencies.lazy').then((d) => d.Route))
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/dashboard.lazy').then((d) => d.Route))
const AppDebugRoute = AppDebugRouteImport.update({
            id: '/debug',path: '/debug',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/debug.lazy').then((d) => d.Route))
const AppExploreRoute = AppExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/explore.lazy').then((d) => d.Route))
const AppExploreAllRoute = AppExploreAllRouteImport.update({
            id: '/explore-all',path: '/explore-all',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/explore-all.lazy').then((d) => d.Route))
const AppInvestingAccountRoute = AppInvestingAccountRouteImport.update({
            id: '/investing-account',path: '/investing-account',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/investing-account.lazy').then((d) => d.Route))
const AppOnboardingRoute = AppOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AppRoute
          })
const AppOnboardingV2Route = AppOnboardingV2RouteImport.update({
            id: '/onboarding-v2',path: '/onboarding-v2',getParentRoute: () => AppRoute
          })
const AppPreIpoRoute = AppPreIpoRouteImport.update({
            id: '/pre-ipo',path: '/pre-ipo',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/pre-ipo.lazy').then((d) => d.Route))
const AppPrivateCreditRoute = AppPrivateCreditRouteImport.update({
            id: '/private-credit',path: '/private-credit',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/private-credit.lazy').then((d) => d.Route))
const AppReferralsRoute = AppReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/referrals.lazy').then((d) => d.Route))
const AppRewardsRoute = AppRewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/rewards.lazy').then((d) => d.Route))
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/settings.lazy').then((d) => d.Route))
const AppStocksRoute = AppStocksRouteImport.update({
            id: '/stocks',path: '/stocks',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/stocks.lazy').then((d) => d.Route))
const DesignSystemIndexRoute = DesignSystemIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DesignSystemRoute
          }).lazy(() => import('./routes/design-system.index.lazy').then((d) => d.Route))
const DesignSystemSlugRoute = DesignSystemSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => DesignSystemRoute
          }).lazy(() => import('./routes/design-system.$slug.lazy').then((d) => d.Route))
const RSlugRoute = RSlugRouteImport.update({
            id: '/r/$slug',path: '/r/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/r.$slug.lazy').then((d) => d.Route))
const StartStepIdRoute = StartStepIdRouteImport.update({
            id: '/$stepId',path: '/$stepId',getParentRoute: () => StartRoute
          }).lazy(() => import('./routes/start.$stepId.lazy').then((d) => d.Route))
const WelcomeStepIdRoute = WelcomeStepIdRouteImport.update({
            id: '/$stepId',path: '/$stepId',getParentRoute: () => WelcomeRoute
          }).lazy(() => import('./routes/welcome.$stepId.lazy').then((d) => d.Route))
const AppAgentsWorkflowIdRoute = AppAgentsWorkflowIdRouteImport.update({
            id: '/$workflowId',path: '/$workflowId',getParentRoute: () => AppAgentsRoute
          }).lazy(() => import('./routes/_app/agents.$workflowId.lazy').then((d) => d.Route))
const AppAgentsTasksRoute = AppAgentsTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AppAgentsRoute
          }).lazy(() => import('./routes/_app/agents.tasks.lazy').then((d) => d.Route))
const AppBuildBlueprintIdRoute = AppBuildBlueprintIdRouteImport.update({
            id: '/build_/$blueprintId',path: '/build/$blueprintId',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/build_.$blueprintId.lazy').then((d) => d.Route))
const AppCryptoSymbolRoute = AppCryptoSymbolRouteImport.update({
            id: '/crypto_/$symbol',path: '/crypto/$symbol',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/crypto_.$symbol.lazy').then((d) => d.Route))
const AppOnboardingOnboardingIdRoute = AppOnboardingOnboardingIdRouteImport.update({
            id: '/$onboardingId',path: '/$onboardingId',getParentRoute: () => AppOnboardingRoute
          }).lazy(() => import('./routes/_app/onboarding.$onboardingId.lazy').then((d) => d.Route))
const AppPortfolioPortfolioInstanceIdRoute = AppPortfolioPortfolioInstanceIdRouteImport.update({
            id: '/portfolio/$portfolioInstanceId',path: '/portfolio/$portfolioInstanceId',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/portfolio.$portfolioInstanceId.lazy').then((d) => d.Route))
const AppReceiptReceiptIdRoute = AppReceiptReceiptIdRouteImport.update({
            id: '/receipt/$receiptId',path: '/receipt/$receiptId',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/receipt.$receiptId.lazy').then((d) => d.Route))
const AppSpPartnerRoute = AppSpPartnerRouteImport.update({
            id: '/sp/$partner',path: '/sp/$partner',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/sp.$partner.lazy').then((d) => d.Route))
const AppStocksSymbolRoute = AppStocksSymbolRouteImport.update({
            id: '/stocks_/$symbol',path: '/stocks/$symbol',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/stocks_.$symbol.lazy').then((d) => d.Route))
const AppStrategyBlueprintIdRoute = AppStrategyBlueprintIdRouteImport.update({
            id: '/strategy/$blueprintId',path: '/strategy/$blueprintId',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/strategy.$blueprintId.lazy').then((d) => d.Route))
const AppSymbolSymbolRoute = AppSymbolSymbolRouteImport.update({
            id: '/symbol/$symbol',path: '/symbol/$symbol',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/symbol.$symbol.lazy').then((d) => d.Route))
const AppTemplateBlueprintIdRoute = AppTemplateBlueprintIdRouteImport.update({
            id: '/template/$blueprintId',path: '/template/$blueprintId',getParentRoute: () => AppRoute
          })
const AppUserUserIdRoute = AppUserUserIdRouteImport.update({
            id: '/user/$userId',path: '/user/$userId',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/user.$userId.lazy').then((d) => d.Route))
const OnrampRobinhoodCallbackRoute = OnrampRobinhoodCallbackRouteImport.update({
            id: '/onramp/robinhood/callback',path: '/onramp/robinhood/callback',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/onramp.robinhood.callback.lazy').then((d) => d.Route))
const AppAgentsTasksTaskIdRoute = AppAgentsTasksTaskIdRouteImport.update({
            id: '/$taskId',path: '/$taskId',getParentRoute: () => AppAgentsTasksRoute
          }).lazy(() => import('./routes/_app/agents.tasks.$taskId.lazy').then((d) => d.Route))
const AppAssetChainIdTokenAddressRoute = AppAssetChainIdTokenAddressRouteImport.update({
            id: '/asset/$chainId/$tokenAddress',path: '/asset/$chainId/$tokenAddress',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/asset.$chainId.$tokenAddress.lazy').then((d) => d.Route))
const AppCryptoChainTokenAddressRoute = AppCryptoChainTokenAddressRouteImport.update({
            id: '/crypto_/$chain/$tokenAddress',path: '/crypto/$chain/$tokenAddress',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/crypto_.$chain.$tokenAddress.lazy').then((d) => d.Route))
const AppSymbolChainIdSymbolRoute = AppSymbolChainIdSymbolRouteImport.update({
            id: '/symbol/$chainId/$symbol',path: '/symbol/$chainId/$symbol',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/_app/symbol.$chainId.$symbol.lazy').then((d) => d.Route))





const AppAgentsTasksRouteChildren = {
  AppAgentsTasksTaskIdRoute: AppAgentsTasksTaskIdRoute
}

const AppAgentsTasksRouteWithChildren = AppAgentsTasksRoute._addFileChildren(AppAgentsTasksRouteChildren)



const AppAgentsRouteChildren = {
  AppAgentsWorkflowIdRoute: AppAgentsWorkflowIdRoute,AppAgentsTasksRoute: AppAgentsTasksRouteWithChildren
}

const AppAgentsRouteWithChildren = AppAgentsRoute._addFileChildren(AppAgentsRouteChildren)




const AppOnboardingRouteChildren = {
  AppOnboardingOnboardingIdRoute: AppOnboardingOnboardingIdRoute
}

const AppOnboardingRouteWithChildren = AppOnboardingRoute._addFileChildren(AppOnboardingRouteChildren)



const AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,AppAgentsRoute: AppAgentsRouteWithChildren,AppBondsRoute: AppBondsRoute,AppBoostedLimitOrdersRoute: AppBoostedLimitOrdersRoute,AppBuildRoute: AppBuildRoute,AppCommoditiesRoute: AppCommoditiesRoute,AppCreatePortfolioRoute: AppCreatePortfolioRoute,AppCryptoRoute: AppCryptoRoute,AppCurrenciesRoute: AppCurrenciesRoute,AppDashboardRoute: AppDashboardRoute,AppDebugRoute: AppDebugRoute,AppExploreRoute: AppExploreRoute,AppExploreAllRoute: AppExploreAllRoute,AppInvestingAccountRoute: AppInvestingAccountRoute,AppOnboardingRoute: AppOnboardingRouteWithChildren,AppOnboardingV2Route: AppOnboardingV2Route,AppPreIpoRoute: AppPreIpoRoute,AppPrivateCreditRoute: AppPrivateCreditRoute,AppReferralsRoute: AppReferralsRoute,AppRewardsRoute: AppRewardsRoute,AppSettingsRoute: AppSettingsRoute,AppStocksRoute: AppStocksRoute,AppBuildBlueprintIdRoute: AppBuildBlueprintIdRoute,AppCryptoSymbolRoute: AppCryptoSymbolRoute,AppPortfolioPortfolioInstanceIdRoute: AppPortfolioPortfolioInstanceIdRoute,AppReceiptReceiptIdRoute: AppReceiptReceiptIdRoute,AppSpPartnerRoute: AppSpPartnerRoute,AppStocksSymbolRoute: AppStocksSymbolRoute,AppStrategyBlueprintIdRoute: AppStrategyBlueprintIdRoute,AppSymbolSymbolRoute: AppSymbolSymbolRoute,AppTemplateBlueprintIdRoute: AppTemplateBlueprintIdRoute,AppUserUserIdRoute: AppUserUserIdRoute,AppAssetChainIdTokenAddressRoute: AppAssetChainIdTokenAddressRoute,AppCryptoChainTokenAddressRoute: AppCryptoChainTokenAddressRoute,AppSymbolChainIdSymbolRoute: AppSymbolChainIdSymbolRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const DesignSystemRouteChildren = {
  DesignSystemSlugRoute: DesignSystemSlugRoute,DesignSystemIndexRoute: DesignSystemIndexRoute
}

const DesignSystemRouteWithChildren = DesignSystemRoute._addFileChildren(DesignSystemRouteChildren)




const StartRouteChildren = {
  StartStepIdRoute: StartStepIdRoute
}

const StartRouteWithChildren = StartRoute._addFileChildren(StartRouteChildren)




const WelcomeRouteChildren = {
  WelcomeStepIdRoute: WelcomeStepIdRoute
}

const WelcomeRouteWithChildren = WelcomeRoute._addFileChildren(WelcomeRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,AiSandboxRoute: AiSandboxRoute,ApiRoute: ApiRoute,DesignSystemRoute: DesignSystemRouteWithChildren,DevelopersRoute: DevelopersRoute,LoginRoute: LoginRoute,OnboardingV1PreviewRoute: OnboardingV1PreviewRoute,PlatformRoute: PlatformRoute,PolicyRoute: PolicyRoute,StartRoute: StartRouteWithChildren,TermsRoute: TermsRoute,WelcomeRoute: WelcomeRouteWithChildren,RSlugRoute: RSlugRoute,OnrampRobinhoodCallbackRoute: OnrampRobinhoodCallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)